import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DOB_INPUT_DATE } from "@jti/fe-common";
import { getUser } from "@jti/rest-api";
import { selectAccountContact, updateAgeVerification, useDispatch, useSelector } from "@jti/store";
import { AgeVerificationBanner, Form, formatDate, useForm } from "@jti/ui";
import { CartItems } from "../../../../components/CartItems";
import { useAemModel } from "../../../../contexts/AemModelContext";
export const CartPageContent = ({ isCartItemsLimitReached = false, isAgeVerificationErrorVisible, }) => {
    const dispatch = useDispatch();
    const user = getUser();
    const { ageVerificationPopup, ageVerificationMethodImages } = useAemModel();
    const accountContactData = useSelector(selectAccountContact);
    const isLimitEnabled = useSelector((state) => state.cart.storeConfig?.is_order_limit_enabled);
    const profileDataFetchStatus = useSelector((state) => state.checkout.profileDataFetchStatus);
    const isAgeVerificationSuccess = useSelector((state) => state.checkout.isAgeVerificationSuccess);
    const updateAgeVerificationPending = useSelector((state) => state.checkout.updateAgeVerificationPending);
    const form = useForm({
        defaultValues: {},
    });
    const onSuccess = async (avpUuid) => {
        dispatch(updateAgeVerification({ avpUuid }));
    };
    return (_jsxs(_Fragment, { children: [(isAgeVerificationErrorVisible || isAgeVerificationSuccess) && (_jsx(Form, { form: form, onSubmit: () => null, dataTestId: "ageVerificationForm", children: _jsx(AgeVerificationBanner, { isPending: updateAgeVerificationPending || profileDataFetchStatus === "pending", dialogDescription: ageVerificationPopup?.description || "", onSuccess: onSuccess, isAgeVerificationSuccess: isAgeVerificationSuccess, ageVerificationMethodImages: ageVerificationMethodImages || {}, mode: ageVerificationPopup?.popupMode ? "popup" : "link", successMessage: ageVerificationPopup?.successMessage || "", userData: {
                        firstname: accountContactData?.firstname,
                        lastname: accountContactData?.lastname,
                        phone: accountContactData?.telephone,
                        email: user.email,
                        dateOfBirth: formatDate(accountContactData?.dob, DOB_INPUT_DATE),
                    } }) })), _jsx(CartItems, { isLimitEnabled: isLimitEnabled, warningStatus: isCartItemsLimitReached })] }));
};
//# sourceMappingURL=CartPageContent.js.map